import {getCssSizeValue, getHtmlFromRedactorField, isStringEmpty} from "@/utils/utils";
import LinkButton from "@/components/common/Buttons/LinkButton";
import {BUTTON_VARIANTS, ICONS} from "@/constants";
import React from "react";
import styled from "styled-components";
import {BREAKPOINTS} from "@/styles/themeSettings";
import CommonIcon from "@/components/common/Icon/Icon";
import {ACTIVE_STATE} from "@/components/common/Cards";
import NotActiveBadge from "@/components/common/NotActiveBadge";


const ActiveItemContent = styled.div`
	position: relative;
	min-height: 30vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: ${({theme}) => theme.colors.richBlack};
	background-color: ${({theme}) => theme.colors.white};
	
	padding:
		${getCssSizeValue(24, BREAKPOINTS.MOBILE)}
		${getCssSizeValue(16, BREAKPOINTS.MOBILE)}
		${getCssSizeValue(32, BREAKPOINTS.MOBILE)}
		${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
	
    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        padding:
			${getCssSizeValue(60)}
			${getCssSizeValue(40)}
			${getCssSizeValue(40)}
			${getCssSizeValue(40)};
    }

    div {
        &.with-button {
            .description {
                margin-bottom: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
                @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
                    margin-bottom: ${getCssSizeValue(40)};
                }
            }
		}

		&.header {
            margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

            @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
				margin-bottom: ${getCssSizeValue(40)};
            }
		}
	
		&.description {
			margin-bottom: 0;
		}
	}
	
	div.buttons {
		display: flex;
		gap: ${getCssSizeValue(16)};
	}

    span[style="text-decoration: line-through;"] {
        text-decoration: none !important;
        background-color: ${({theme}) => theme.colors.periwinkle};
        line-height: 35%;
        display: inline-block;
    }
`

const Icon = styled(CommonIcon)`
    height: 14px;
    width: 14px;
`

export default function BannerCard({ data }) {
	const header = data?.header || ''
	const description = data?.description || ''
	const secondButtonExist = !isStringEmpty( data?.secondButton?.link?.text || '')
	const firstButtonExist = !isStringEmpty(data?.firstButton?.link?.text || '')
	const isActive = data?.assignTo?.active || ACTIVE_STATE.YES

	return (
		<ActiveItemContent className='col-desktop-5 col-tablet-5 col-mobile-7'>
			{isActive === ACTIVE_STATE.NO && (
				<NotActiveBadge />
			)}
			<div className={`${(secondButtonExist || firstButtonExist) ? 'with-button' : ''}`}>
				<div className='header typo-borna typo-borna-08' dangerouslySetInnerHTML={getHtmlFromRedactorField(header)}/>
				<div className='typo-strawford typo-strawford-09 description' dangerouslySetInnerHTML={getHtmlFromRedactorField(description)}/>
			</div>
			<div className='buttons'>
				{firstButtonExist && (
					<LinkButton data={data?.firstButton} variant={BUTTON_VARIANTS.SECONDARY} />
				)}
				{secondButtonExist && (
					<LinkButton data={data?.secondButton}>
						<Icon name={ICONS.CHEVRON}/>
					</LinkButton>
				)}
			</div>
		</ActiveItemContent>
	)
}